import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { generateLink } from '../../../../../shared/utils/railsRoutes';
import { useNoIndexNoFollow } from '../../../../../shared/utils/hooks/useNoIndexNoFollow';

import UrlParamsHandler from './utils/UrlParamsHandler';
import Map from './components/Map';
import RadiusSelector from './components/RadiusSelector';
import RadarGeocoder from './components/RadarGeocoder';
import PropertyModal from './modals/PropertyModal';
import LoginSignupModal from './modals/LoginSignupModal';
import PhoneNumberModal from './modals/PhoneNumberModal';
import NoResultsModal from './modals/NoResultsModal';
import GlassCard from './components/lib/GlassCard';

import { HosmanLogo, Button } from 'hosman-material';
import { D_Radar, D_MapPin } from 'hosman-material';

import { updateDisplayRecenterPin, getRadarProperties, updateUserProject, getRadarLeadsCount } from '../../../../reducers/_Pages/Public/radarSlice';
import RADAR_SEARCHES from '../../../../api/ressources/App/radarSearches';

const Radar = () => {
  const { user } = useSelector((state) => state.user);
  const { addressObj, coordinates, radius, displayRecenterPin, userProject } = useSelector((state) => state.radar);
  const dispatch = useDispatch();
  useNoIndexNoFollow();

  useEffect(() => {
    if (!addressObj.lat) return;
    
    dispatch(getRadarProperties(
      {
        radius: radius,
        lat: coordinates[1],
        lng: coordinates[0]
      }
    ))

    if (user.id) {
      createRadarSearch()
    }
  }, [addressObj.lat, coordinates, radius]);

  useEffect(() => {
    if (!user.id) return; 
    
    dispatch(getRadarLeadsCount())
  }, [user.id]);

  const createRadarSearch = () => {
    const params = { ...addressObj, project: userProject }

    dispatch(updateUserProject(null))
    RADAR_SEARCHES.createSearch(params)
  }

  return (
    <div className='relative bg-ih-neutral pointer-events-none'>
      <UrlParamsHandler />
      <Map />

      <div className='hidden sm:block'>
        <a href={generateLink(RailsRoutes.root_path())} className='absolute top-6 left-8 pointer-events-auto z-40'>
          <HosmanLogo rgbColor='#ffffff' />
        </a>

        <a href='/estimation' className='absolute top-4 right-10 pointer-events-auto' target='_blank'>
          <Button label='Estimer un bien' type='custom' customColors='bg-white' />
        </a>
      </div>

      <div className='absolute left-1/2 top-0 -translate-x-1/2 z-20 w-full md:w-auto'>
        <div className='flex flex-col justify-between gap-6 text-white h-[100dvh] p-5'>
          <GlassCard>
            <div className='flex flex-col gap-3 p-2'>
              <div className='font-quantico text-white text-center w-max mx-auto'>
                <div className='flex items-center gap-5'>
                  <FontAwesomeIcon icon={D_Radar} className='text-ih-blue text-3xl xl:text-5xl' />
                  <h1 className='h2 xl:h1'>le radar</h1>
                </div>
              </div>
              <p className='font-semibold'>Scannez votre marché local grâce à la data des ventes Hosman</p>
            </div>
          </GlassCard>

          <div className='flex flex-col gap-6 pointer-events-auto'>
            <div className='flex flex-col gap-3'>
              <p className='text-center xl:text-left font-bold'>Positionnez votre radar</p>
              <div className='flex items-end gap-3 pointer-events-auto'>
                <RadarGeocoder />
                
                <GlassCard
                  width='w-12'
                  height='h-12'
                  clickEffect
                  onClick={() => dispatch(updateDisplayRecenterPin(!displayRecenterPin))}
                >
                  <div className='flex items-center justify-center'>
                    <FontAwesomeIcon icon={D_MapPin} size='lg' />
                  </div>
                </GlassCard>
              </div>
            </div>

            <RadiusSelector />
          </div>
        </div>
      </div>

      <PropertyModal />
      <LoginSignupModal />
      <PhoneNumberModal />
      <NoResultsModal />
    </div>
  )
}

export default Radar;
